import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class CoreEventAvService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/av_equipments`);
  }

  saveCompany(body: any, urlParams: any): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/av_company`, urlParams);
    return this.http.post<any>(url, body);
  }

  saveEquipments(body: any, urlParams: any): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams);
    return this.http.post<any>(url, body);
  }
}
